import Tilt from "react-parallax-tilt";

export function TiltCard({ children, ...props }) {
  return (
    <Tilt
      glareEnable={false}
      tiltMaxAngleX={8}
      tiltMaxAngleY={8}
      transitionSpeed={700}
      scale={1.03}
      className="will-change-transform"
      {...props}
    >
      {children}
    </Tilt>
  );
} 